import { useMutation } from "react-query";

import { zodParseWithLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { OpenFoodFactsResolvedProduct, OpenFoodFactsResolvedProductSchema } from "./types";

export const openFoodFactsResolveKey = "openFoodFactsResolve" as const;

export const useOpenFoodFactsResolve = () => {
    return useMutation<OpenFoodFactsResolvedProduct, unknown, string>({
        mutationFn: async (code: string) => {
            const response = await loggedInApiCall.get(`/api/open-food-facts/products/${code}`);

            return zodParseWithLog(response.data, OpenFoodFactsResolvedProductSchema, openFoodFactsResolveKey);
        },
    });
};
